import { TextInputFormikPropTypes, TextInputFormikDefaultProps } from '../../Utils/TextInputPropTypes';

export const InputPhone2PropTypes = TextInputFormikPropTypes;

export const InputPhone2DefaultProps = TextInputFormikDefaultProps;

export default { InputPhone2PropTypes, InputPhone2DefaultProps };
